module.exports = " <div class=vux-checker-box> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/checker/checker.vue
// module id = 210
// module chunks = 2